import { RefObject } from "react";

export const updateListPosition = (
    listElement: RefObject<HTMLButtonElement>,
    selectField: RefObject<HTMLButtonElement>,
    setIsOpen: (value: boolean) => void,
    scrollParent: HTMLElement | null,
) => {
    if (listElement.current && selectField.current) {
        const {
            x: selectX,
            y: selectY,
            width: selectWidth,
            height: seleectHeight,
        } = selectField.current.getBoundingClientRect();

        const listHeight = listElement.current.getBoundingClientRect().height;
        const spacing = 9;
        let newY = selectY + seleectHeight;

        const listBottom = newY + listHeight;

        if (listBottom > window.innerHeight - 24) newY -= seleectHeight + listHeight + spacing;

        listElement.current.style.setProperty("transform", `translate(${selectX}px, ${newY}px)`);
        listElement.current.style.setProperty("width", `${selectWidth}px`);

        if (scrollParent) {
            const { y: scrollTop, height: scrollHeight } = scrollParent.getBoundingClientRect();

            if (selectY + seleectHeight > scrollTop + scrollHeight || selectY < scrollTop) {
                setIsOpen(false);
            }
        }
    }
};
